export default __webpack_public_path__ + "static/media/backpack.bccaf796.svg";